import { getApi } from 'util/api';
import { client, formatQueryParams } from 'util/sdk';

export const load = (params, { id }) =>
  getApi(`/auth/adminusers/${id}/admingroups`, params);

export const loadByOrgId = ({ organizationId, ...props }) =>
  client.admin
    .organizations(organizationId)
    .groups.query(formatQueryParams(props));

export const addGroup = (data, auth) =>
  client.admin.groups.create(data, { adminUserId: auth.id });

export const deleteGroup = ({ id }, auth) =>
  client.admin.groups(id).delete({ adminUserId: auth.id });

export const updateGroup = (
  { description, fspAccesses, groupAdmins, id, name, roles },
  auth
) =>
  client.admin
    .groups(id)
    .update(
      { description, fspAccesses, groupAdmins, name, roles },
      { adminUserId: auth.id }
    );
